module.exports = __webpack_public_path__ + "media/images/play-button-c56c3a67ad525b31e18c486edd3366fd.svg";